// Base routes file, contains routes to global modules, as well as imports the
// routes file from each module

import { createRouter, createWebHistory } from 'vue-router';
import BaseRouter from './components/BaseRouter.vue';
import { loginRoutes } from './../loginModule/routes';
import { projectManagerRoutes } from './../projectManagerModule/routes';
import { nodesCanvasRoutes } from '../nodesCanvasModule/routes';
import { authObserver } from '@/firebase/auth';
import { packageCanvasRoutes } from '../packageCanvas/routes';
import { controlCenterRoutes } from '../controlCenterModule/routes';
import { codeViewRoutes } from '../codeViewModule/routes';
import { paymentModuleRoutes } from '../paymentsModule/routes';
import { eduRoutes } from '../eduModule/routes';
const URL = ''; // NOTE: when launching website, change this to global URL

const router = createRouter({
  history: createWebHistory(URL),
  routes: [
    {
      path: '/',
      name: 'BaseRouter',
      component: BaseRouter
    },
    ...loginRoutes,
    ...projectManagerRoutes,
    ...nodesCanvasRoutes,
    ...packageCanvasRoutes,
    ...controlCenterRoutes,
    ...codeViewRoutes,
    ...paymentModuleRoutes,
    ...eduRoutes
    // { path: '/:pathMatch(.*)*', redirect: '/projectManager' }
  ]
});

router.beforeEach(async (to, from) => {
  if (to.name?.toString().includes('Login')) return true;
  const user = await new Promise((resolve) => {
    authObserver((user) => {
      resolve(user);
    });
  });
  if (!user) {
    return { name: 'Login.SignIn' };
  }
});

export default router;
